import React from 'react';
import HeroSection from './HeroSection';
import WhyUsSection from './WhyUsSection';
import RobertBruggeman from './RobertBruggeman';
import WhatYouCanGet from './WhatYouCanGet';
import StackTheOdds from './StackTheOdds';
import JoinTheClub from './JoinTheClub';
const HomePage: React.FC = () => {
  return (
    <div className="min-h-screen">
      <HeroSection />
      <WhyUsSection />
      <RobertBruggeman />
      <WhatYouCanGet />
      <StackTheOdds />
      <JoinTheClub />
    </div>
  );
};

export default HomePage;
